module.exports = __webpack_public_path__ + "img/Flag_Belgique.d5c0939c.svg";